/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungStandortErfuellungDto } from '../../models/lexplus-anforderung-standort-erfuellung-dto';
import { LexplusUpdateAnforderungErfuellungsgradDto } from '../../models/lexplus-update-anforderung-erfuellungsgrad-dto';

export interface AnforderungDetailControllerUpdateAnforderungErfuellungsgradV1$Params {
  anforderungsversionID: number;
  standortID: number;
      body: LexplusUpdateAnforderungErfuellungsgradDto
}

export function anforderungDetailControllerUpdateAnforderungErfuellungsgradV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerUpdateAnforderungErfuellungsgradV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungStandortErfuellungDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerUpdateAnforderungErfuellungsgradV1.PATH, 'patch');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('standortID', params.standortID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungStandortErfuellungDto>;
    })
  );
}

anforderungDetailControllerUpdateAnforderungErfuellungsgradV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/standorte/{standortID}/erfuellungsgrad';
